import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Button } from '../../../components/button'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Link } from 'react-router-dom';
import { ModuleHeader } from '../../../components/module-header'
import { LibrarySubjects } from '../../../components/library-subjects'
import { LibraryMedia } from '../../../components/library-media'
import { UploadButtonContainer } from '../../../styles/library';


const Library = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <UploadButtonContainer>
                            <Link to="/teacher/library/upload">
                                <Button variant="secondary">Upload</Button>
                            </Link>
                        </UploadButtonContainer>
                        <Heading>
                            Library
                        </Heading>
                        <Breadcrumb
                            crumbs={['library']}
                        />
                        <ModuleHeader title="SCIENCE BOOKS" />
                        <LibrarySubjects />

                        <ModuleHeader title="MEDIA" />
                        <LibraryMedia />
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default Library
